import { render, staticRenderFns } from "./admin-report-start.vue?vue&type=template&id=785c5160&scoped=true&"
import script from "./admin-report-start.vue?vue&type=script&lang=js&"
export * from "./admin-report-start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c5160",
  null
  
)

export default component.exports